// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zar4","right":"styles_right__1Qun2"};